export const IS_DISMISSED_FLAG = 'false';

export const isOnboardingStateEqual =
	(onboardingStateKey: string, onboardingStateValue: string) =>
	({ key, value }: { key: string; value: string | null }) =>
		key === onboardingStateKey && value === onboardingStateValue;
